module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "navbar-brand",
    on: {
      "click": _vm.scrollToIntro
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        params: {
          intro: true
        }
      }
    }
  }, [_vm._v("Colin Stevenson")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "navbar-right nav navbar-nav"
  }, [_c('li', {
    staticClass: "photography-tab",
    class: {
      active: _vm.isPhotographyRoute
    },
    attrs: {
      "id": "photography-tab"
    },
    on: {
      "click": _vm.scrollToMain
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        params: {
          intro: false
        }
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("Photography")]), _vm._v(" "), _c('span', {
    staticClass: "visible-xs"
  }, [_vm._v("Photos")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aa687ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 123
// module chunks = 2